import React, { memo } from 'react';
import { createStackNavigator, TransitionPresets } from '@react-navigation/stack';
import { routes, HOME_PAGE, WELCOME_SCREEN } from './routes';

const Stack = createStackNavigator();

/**
 * StackNavigatorLandscape
 *
 * Creates a single nested stack navigator that wraps the Tab Navigator in landscape mode.
 * This keeps the tabbar visible when navigating to other routes.
 *
 * 
 *
**/ 

const StackNavigatorLandscape = ({ children }) => {


    return (
        <Stack.Navigator
            screenOptions={{
                headerShown: false,
                ...TransitionPresets.SlideFromRightIOS,
            }}
        >
            {/* Tab Navigator - initial route */}
            <Stack.Screen
                name={'main'}
                children={() => children}
            />

            {/* Include all app routes (except HOME_PAGE/WELCOME_SCREEN) so any navigation keeps tabbar visible */}
            {routes
                .filter(r => r.name !== HOME_PAGE && r.name !== WELCOME_SCREEN)
                .map(r => (
                    <Stack.Screen
                        key={r.name}
                        name={r.name}
                        component={r.component}
                        options={r.options}
                    />
                ))}
        </Stack.Navigator>
    );
};

export default memo(StackNavigatorLandscape);
